module.exports = __webpack_public_path__ + "static/img/mute_camera2.4087724.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/mute_camera2.png
// module id = E77Z
// module chunks = 24